import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, ArrowUpRight } from "lucide-react";
import { AutomexLogo } from "@/components/common/AutomexLogo";
import { CONTACT } from "@/data/site";

const solutions = [
  "Industrial Infrastructure", "Turnkey Projects", "Industrial Machinery", "Automation", "Material Handling", "Industrial Technology",
];
const quickLinks = [
  { label: "About", to: "/about" },
  { label: "Solutions", to: "/solutions" },
  { label: "Projects", to: "/projects" },
  { label: "Industries", to: "/industries" },
  { label: "Company Profile", to: "/company-profile" },
  { label: "Contact", to: "/contact" },
  { label: "Privacy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
];

export function Footer() {
  return (
    <footer className="bg-white text-automex-ink border-t border-slate-200" data-testid="site-footer">
      <div className="bg-blueprint">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16 md:py-20">
          <div className="grid gap-12 lg:grid-cols-12">
            <div className="lg:col-span-4">
              <AutomexLogo variant="dark" />
              <p className="mt-6 font-heading text-2xl font-extrabold uppercase leading-tight tracking-tight text-automex-ink">
                Building Industry.<br />
                <span className="text-automex-blue">Enabling Technology.</span>
              </p>
              <div className="mt-6 space-y-1 text-sm text-slate-600">
                <div className="font-semibold text-automex-ink">Business Verticals</div>
                <div>AutoMex Infra Projects</div>
                <div>AutoMex Industrial Technologies</div>
              </div>
            </div>

            <div className="lg:col-span-3">
              <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-automex-blue">Solutions</h3>
              <ul className="mt-5 space-y-3 text-sm text-slate-600">
                {solutions.map((s) => (
                  <li key={s}>{s}</li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-2">
              <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-automex-blue">Company</h3>
              <ul className="mt-5 space-y-3 text-sm">
                {quickLinks.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-slate-600 hover:text-automex-blue transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-3">
              <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-automex-blue">Contact</h3>
              <ul className="mt-5 space-y-4 text-sm text-slate-600">
                <li className="flex items-start gap-3">
                  <MapPin className="h-4 w-4 mt-0.5 text-automex-teal shrink-0" />
                  <span>{CONTACT.location}</span>
                </li>
                <li>
                  <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 hover:text-automex-blue transition-colors" data-testid="footer-phone">
                    <Phone className="h-4 w-4 text-automex-teal shrink-0" />{CONTACT.phone}
                  </a>
                </li>
                <li>
                  <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-automex-blue transition-colors" data-testid="footer-email">
                    <Mail className="h-4 w-4 text-automex-teal shrink-0" />{CONTACT.email}
                  </a>
                </li>
                <li>
                  <a href={CONTACT.linkedinInfra} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-automex-blue transition-colors" data-testid="footer-linkedin-infra">
                    <Linkedin className="h-4 w-4 text-automex-teal shrink-0" />LinkedIn — Infra Projects
                    <ArrowUpRight className="h-3 w-3" />
                  </a>
                </li>
                <li>
                  <a href={CONTACT.linkedinTech} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-automex-blue transition-colors" data-testid="footer-linkedin-tech">
                    <Linkedin className="h-4 w-4 text-automex-teal shrink-0" />LinkedIn — Industrial Technologies
                    <ArrowUpRight className="h-3 w-3" />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
            <span>© {new Date().getFullYear()} AutoMex Group. All rights reserved.</span>
            <span className="uppercase tracking-[0.2em]">Industrial Infrastructure &amp; Technology · Pune, India</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
